import { ProDocExtractionQueue } from '@fiveox/prodoc-ui'
import { PageHeader, buttonClass } from '@fiveox/ui'
import { Link, useNavigate } from 'react-router'

import { useOrg } from '../components/org-context'
import { SERVICE_API } from '../lib/config'
import { session } from '../lib/session'
import { extractionAddress } from './extraction'

/**
 * Extractions — what the engine read and a person must check (engine W15,
 * FR-E20): an extraction waits here when a check does not add up, whose
 * document it is is not certain, AI helped, or the organisation accepts
 * nothing automatically. A thin host (ADR-0010) over `<ProDocExtractionQueue>`;
 * picking one opens its review at its own address.
 *
 * W24 (FR-56, D73): **the queue hands the review its order** — ids only, in the
 * route's state (`walk`), so the review's Previous / Next and J / K walk the
 * queue as it was shown, oldest first, and a reload of the review keeps it.
 *
 * Routed behind `can_update` on `extraction` (`router.tsx`): a reader without
 * it is redirected to Overview rather than shown an empty page.
 */
export function ExtractionQueuePage() {
  const { org, userId } = useOrg()
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <PageHeader
        title="Extractions"
        description="What ProDoc read from a document and a person must check, oldest first. Check each beside its page, correct what it misread, then accept or reject it — its app is told. In a review, J and K open the next and the previous."
      />
      <ProDocExtractionQueue
        apiUrl={SERVICE_API}
        fetcher={session.authed}
        orgId={org.id}
        userId={userId}
        onOpen={(item, walk) => navigate(extractionAddress(item, true), { state: { walk } })}
        emptyAction={
          <Link to="/documents" className={buttonClass({ variant: 'outline' })}>
            Open documents
          </Link>
        }
      />
    </div>
  )
}
